module.exports = __webpack_public_path__ + "media/cold-ammonia-machine.8f6cffe5.mp3";